import { Container, Typography, Paper, Grid } from '@mui/material';
import { Helmet } from 'react-helmet';
import StaticPageLayout from '../components/layout/StaticPageLayout';

export default function PrivacyPolicy() {
  return (
    <StaticPageLayout>
      <Helmet>
        <title>Privacy Policy - ET-Business Directory | Data Protection Guidelines</title>
        <meta name="description" content="Read ET-Business Directory's privacy policy. Learn how we protect your data, handle business information, and maintain user privacy while providing Ethiopian business directory services." />
      </Helmet>

      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Paper sx={{ p: 4, borderRadius: '12px' }}>
              <Typography variant="h4" sx={{ color: '#3A551A', mb: 4, fontWeight: 600 }}>
                Privacy Policy
              </Typography>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Introduction
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, color: '#444', lineHeight: 1.8 }}>
                At ET-Business Directory, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our business directory platform.
              </Typography>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Information We Collect
              </Typography>
              <Typography variant="h6" sx={{ color: '#3A551A', mb: 2 }}>
                Business Information
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, color: '#444', lineHeight: 1.8 }}>
                We collect and display business-related information including:
              </Typography>
              <ul style={{ color: '#444', marginBottom: '2rem', paddingLeft: '1.5rem' }}>
                <li>Business name and description</li>
                <li>Contact information (phone numbers, email addresses)</li>
                <li>Physical address and location data</li>
                <li>Business categories and services offered</li>
                <li>Operating hours and availability</li>
              </ul>

              <Typography variant="h6" sx={{ color: '#3A551A', mb: 2 }}>
                User Information
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, color: '#444', lineHeight: 1.8 }}>
                When you interact with our platform, we may collect:
              </Typography>
              <ul style={{ color: '#444', marginBottom: '2rem', paddingLeft: '1.5rem' }}>
                <li>Search queries and browsing history</li>
                <li>Device information and IP addresses</li>
                <li>Usage patterns and preferences</li>
                <li>Contact information when provided voluntarily</li>
              </ul>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                How We Use Your Information
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, color: '#444', lineHeight: 1.8 }}>
                We use the collected information to:
              </Typography>
              <ul style={{ color: '#444', marginBottom: '2rem', paddingLeft: '1.5rem' }}>
                <li>Provide and maintain our business directory services</li>
                <li>Improve user experience and platform functionality</li>
                <li>Analyze usage patterns and optimize our services</li>
                <li>Communicate with users about our services</li>
                <li>Protect against unauthorized access and abuse</li>
              </ul>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Data Protection
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, color: '#444', lineHeight: 1.8 }}>
                We implement appropriate security measures to protect your information, including:
              </Typography>
              <ul style={{ color: '#444', marginBottom: '2rem', paddingLeft: '1.5rem' }}>
                <li>Secure data storage and encryption</li>
                <li>Regular security assessments and updates</li>
                <li>Access controls and authentication measures</li>
                <li>Staff training on data protection</li>
              </ul>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Your Rights
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, color: '#444', lineHeight: 1.8 }}>
                You have the right to:
              </Typography>
              <ul style={{ color: '#444', marginBottom: '2rem', paddingLeft: '1.5rem' }}>
                <li>Access your personal information</li>
                <li>Request corrections to your data</li>
                <li>Request deletion of your information</li>
                <li>Opt-out of marketing communications</li>
                <li>File a complaint about data handling</li>
              </ul>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Contact Information
              </Typography>
              <Typography variant="body1" sx={{ color: '#444', lineHeight: 1.8 }}>
                If you have any questions about our Privacy Policy or how we handle your data, please contact us at:
              </Typography>
              <Typography variant="body1" sx={{ mt: 2, color: '#444', lineHeight: 1.8 }}>
                Email: <a href="mailto:privacy@et-business.com" style={{ color: '#3A551A', textDecoration: 'none' }}>privacy@et-business.com</a><br />
                Phone: <a href="tel:+251123456789" style={{ color: '#3A551A', textDecoration: 'none' }}>+251 123 456 789</a><br />
                Address: Bole Road, Addis Ababa, Ethiopia
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </StaticPageLayout>
  );
} 